import { xray } from 'lib/xray';
import { getFeatureAbQuotaLandingExtraTariff, getQuotaLandingTariffsConfig } from 'reactApp/modules/features/features.selectors';
import type { PreparedTariff } from 'reactApp/sections/QuotaLanding/TariffsPlans/types';

import { baseTariffSpace } from '../Tariffs/Tariffs.types';

// tempexp_14397-start
type ExtraTariff = NonNullable<ReturnType<typeof getFeatureAbQuotaLandingExtraTariff>>;

const getTariffsIds = (
    id: string,
    { tariffNameSuffix, yearTariffNameSuffix, monthTariffNameSuffix, tariffId }: { tariffNameSuffix: string } & Partial<ExtraTariff>
) => {
    if (id === tariffId && yearTariffNameSuffix && monthTariffNameSuffix) {
        return {
            monthTariffId: `${id}1m_${monthTariffNameSuffix}`,
            yearTariffId: `${id}1y_${yearTariffNameSuffix}`,
        };
    }

    return {
        monthTariffId: `${id}1m_${tariffNameSuffix}`,
        yearTariffId: `${id}1y_${tariffNameSuffix}`,
    };
};
// tempexp_14397-end

const getActionYearTariffId = (id: string, actionTariffs) => {
    const tariff = actionTariffs.find((item) => {
        return item.id.startsWith(id);
    });

    return tariff?.id || '';
};

export const prepareTariffsList = (
    tariffs: Record<string, any>,
    { tariffsIds, tariffNameSuffix, recommendedId, actionTariffs = [], isAction = false }: ReturnType<typeof getQuotaLandingTariffsConfig>,
    quotaLandingExtraTariff?: ExtraTariff
) => {
    if (Object.entries(tariffs).length === 0) {
        xray.send('quota_tar_list_no_tariffs');
        return [];
    }

    return tariffsIds
        .map((id) => {
            if (id === 'base') {
                const space = { ...baseTariffSpace };

                return {
                    id,
                    isSelected: false,
                    isBase: true,
                    yearSpace: space,
                    monthSpace: space,
                };
            }

            // tempexp_14397-next-line
            const { monthTariffId, yearTariffId } = getTariffsIds(id, {
                tariffNameSuffix,
                ...quotaLandingExtraTariff,
            });

            const actionYearTariffId = getActionYearTariffId(id, actionTariffs);

            const yearTariff = isAction ? tariffs[actionYearTariffId] : tariffs[yearTariffId];
            const monthTariff = tariffs[monthTariffId];

            if (!yearTariff || !monthTariff) {
                const radarSuffix = `${!yearTariff ? '_y' : ''}${!monthTariff ? '_m' : ''}`;
                xray.send(`quota_tar_list_no_tariff_${id}${radarSuffix}`);
                return null;
            }

            const { space: yearSpace, products: yearProducts } = yearTariff;
            const { space: monthSpace, products: monthProducts } = monthTariff;

            const yearPrice = yearProducts[0]?.price;
            const monthPrice = monthProducts[0]?.price;

            const yearDiscountPrice = yearProducts[0]?.discountPrice || yearPrice;
            const giftText = yearProducts[0]?.gift?.space?.value;

            const saving = isAction ? yearPrice - yearDiscountPrice : monthPrice * 12 - yearPrice;
            // tempexp_14397-next-line
            const isRecommended = quotaLandingExtraTariff?.tariffId ? quotaLandingExtraTariff?.tariffId === id : id === recommendedId;

            return {
                id,
                yearSpace,
                monthSpace,
                yearPrice,
                yearDiscountPrice,
                monthPrice,
                saving,
                isRecommended,
                isBase: false,
                monthTariffId,
                yearTariffId: isAction ? actionYearTariffId : yearTariffId,
                giftText,
            };
        })
        .filter(Boolean) as PreparedTariff[];
};

const SCREEN_WIDTH_FOR_ONE_CARDS = 600;
const SCREEN_WIDTH_FOR_TWO_CARDS = 800;
const SCREEN_WIDTH_FOR_THREE_CARDS = 1300;

export const carouselBreakpoints = [
    {
        maxWidth: SCREEN_WIDTH_FOR_ONE_CARDS,
        showCount: 1,
    },
    {
        maxWidth: SCREEN_WIDTH_FOR_TWO_CARDS,
        showCount: 2,
    },
    {
        maxWidth: SCREEN_WIDTH_FOR_THREE_CARDS,
        showCount: 3,
    },
];
